export var LogoScope;
(function (LogoScope) {
    LogoScope[LogoScope["Navbar"] = 0] = "Navbar";
    LogoScope[LogoScope["LoginForm"] = 1] = "LoginForm";
})(LogoScope || (LogoScope = {}));
var UiPathLogoComponent = /** @class */ (function () {
    function UiPathLogoComponent() {
        this.LogoScope = LogoScope;
    }
    Object.defineProperty(UiPathLogoComponent.prototype, "scope", {
        get: function () {
            return this._scope;
        },
        set: function (value) {
            if (!LogoScope[value]) {
                var logoScopeOptions = Object.keys(LogoScope)
                    .filter(function (o) { return isNaN(o); })
                    .join(', ');
                throw new Error("'" + value + "' is an invalid scope. Available options: " + logoScopeOptions + ".");
            }
            this._scope = value;
        },
        enumerable: true,
        configurable: true
    });
    UiPathLogoComponent.prototype.getWidth = function () {
        return this.width + 'px';
    };
    UiPathLogoComponent.prototype.getHeight = function () {
        return this.height + 'px';
    };
    return UiPathLogoComponent;
}());
export { UiPathLogoComponent };
